import React, { Component } from 'react';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';

import './App.css';
import {Route,BrowserRouter,Switch,Redirect} from 'react-router-dom';
import ScrollToTop from './ScrollToTop ';

import Signin from './Pages/Signin/Signin';
import Signup from './Pages/Signup/Signup';
import ConfirmData from './Pages/ConfirmData/ConfirmData';
import ConfirmPhone from './Pages/ConfirmData/ConfirmPhone';
import ConfirmEmail from './Pages/ConfirmData/ConfirmEmail';
import Confirmmaildone from './Pages/ConfirmData/Confirmmaildone';
import ForgetPassword from './Pages/ConfirmData/ForgetPassword';
import Resetpassword from './Pages/ConfirmData/Resetpassword';
import CourierConfirmPhone from './Pages/ConfirmData/CourierConfirmPhone';
import Home from './Pages/Home/Home';
import FAQS from './Pages/FAQS/FAQS';
import Termsconditions from './Pages/Termsconditions/Termsconditions';
import Policy from './Pages/Policy/Policy';
import ContactUs from './Pages/ContactUs/ContactUs';


import SigninAR from './Pages/AR/Signin/Signin';
import SignupAR from './Pages/AR/Signup/Signup';
import ConfirmDataAR from './Pages/AR/ConfirmData/ConfirmData';
import ConfirmPhoneAR from './Pages/AR/ConfirmData/ConfirmPhone';
import ConfirmEmailAR from './Pages/AR/ConfirmData/ConfirmEmail';
import ConfirmmaildoneAR from './Pages/AR/ConfirmData/Confirmmaildone';
import ForgetPasswordAR from './Pages/AR/ConfirmData/ForgetPassword';
import ResetpasswordAR from './Pages/AR/ConfirmData/Resetpassword';
import HomeAR from './Pages/AR/Home/Home';
import FAQSAR from './Pages/AR/FAQS/FAQS';
import TermsconditionsAR from './Pages/AR/Termsconditions/Termsconditions';
import PolicyAR from './Pages/AR/Policy/Policy';
import ContactUsAR from './Pages/AR/ContactUs/ContactUs';

// import SigninCourierAR from './Pages/AR/SigninCourier/SigninCourier';
import SignupCourierAR from './Pages/AR/SignupCourier/SignupCourier';
import CourierConfirmPhoneAR from './Pages/AR/ConfirmData/CourierConfirmPhone';
import SigninAdmin from './Pages/Admin/SigninAdmin/SigninAdmin';
import SignupCourier from './Pages/Admin/SignupCourier/SignupCourier';
import RoutesUser from './RoutesUser';
import RoutesAdmin from './RoutesAdmin';
import NotFoundRoute from './Pages/NotFoundRoute/NotFoundRoute';
class App extends Component  {
  render() {
    if(localStorage.getItem("userToken")){
      return <RoutesUser />
    }else if(localStorage.getItem("AdminTokenKayn")){
      return <RoutesAdmin/>
    }
    else{
  return (
    <div className="App">
      <div className="ForDemo"> DEMO</div>
      <BrowserRouter >
      <ScrollToTop> 
      <Switch>
      <Route exact path='/' component={Home}/>
      <Route exact path='/FAQS' component={FAQS}/>
      <Route exact path='/Termsconditions' component={Termsconditions}/>
      <Route exact path='/Policy' component={Policy}/>
      <Route exact path='/ContactUs' component={ContactUs}/>
      <Route exact path='/Courier/Signup' component={SignupCourier}/>
      <Route exact path='/Courier/ConfirmPhone' component={CourierConfirmPhone}/>
      <Route exact path='/Signin' component={Signin}/>
      <Route exact path='/Signup' component={Signup}/>
      <Route exact path='/ForgetPassword' component={ForgetPassword}/>
      <Route exact path='/Resetpassword/:Token' component={Resetpassword}/>
      <Route exact path='/ConfirmData' component={ConfirmData}/>
      <Route exact path='/ConfirmEmail/:Token' component={ConfirmEmail}/>
      <Route exact path='/ConfirmPhone' component={ConfirmPhone}/>
      <Route exact path='/Confirmchangeemail/:Token' component={Confirmmaildone}/>
      <Route exact path='/Admin/Signin' component={SigninAdmin}/>


       

      <Route exact path='/AR/' component={HomeAR}/>
      <Route exact path='/AR/FAQS' component={FAQSAR}/>
      <Route exact path='/AR/Termsconditions' component={TermsconditionsAR}/>
      <Route exact path='/AR/Policy' component={PolicyAR}/>
      <Route exact path='/AR/ContactUs' component={ContactUsAR}/>
      <Route exact path='/AR/Signin' component={SigninAR}/> 
      <Route exact path='/AR/Signup' component={SignupAR}/>
      <Route exact path='/AR/Courier/Signup' component={SignupCourierAR}/> 
      <Route exact path='/AR/Courier/ConfirmPhone' component={CourierConfirmPhoneAR}/> 
      <Route exact path='/AR/ForgetPassword' component={ForgetPasswordAR}/>
      <Route exact path='/AR/Resetpassword/:Token' component={ResetpasswordAR}/>
      <Route exact path='/AR/ConfirmData' component={ConfirmDataAR}/>
      <Route exact path='/AR/ConfirmEmail/:Token' component={ConfirmEmailAR}/>
      <Route exact path='/AR/ConfirmPhone' component={ConfirmPhoneAR}/>
      <Route exact path='/AR/Confirmchangeemail/:Token' component={ConfirmmaildoneAR}/>
      <Route exact  component={NotFoundRoute}/>

      </Switch>

       
 
        </ScrollToTop>

      </BrowserRouter>
    </div>
  );
}
}
}

export default App;
